import { Icon } from 'components/common';
import useBottomSheet from 'hooks/common/useBottomSheet';
import { useEffect, useState } from 'react';
import { Product } from 'types/model';

const TimeBuffPurchase = () => {
  const { open, close, sheets } = useBottomSheet();
  const sheet = sheets.TimeBuffPurchase;
  const [selectedIdx, setSelectedIdx] = useState<number>();
  const [products, setProducts] = useState<Product[]>([]);

  useEffect(() => {
    setProducts(TimeBuffManager.getTimeBuffProducts() ?? []);

    PurchaseManager.attach(function (err: any, coin: any) {
      if (err) return;

      close(sheet.id);
      open('TimeBuffPurchaseComplete');
    });

    return () => {
      PurchaseManager.detach();
    };
  }, [close, open, sheet.id]);

  const handleClickBundle = (product: Product, idx: number) => {
    setSelectedIdx(idx);
    PurchaseManager.buyCoin(product.productId);
    TimeBuffLogger.logPurchase('clickQuantity', product.productId);
  };

  return (
    <div className="flex h-full w-full flex-col">
      <Icon onClick={() => close(sheet.id)} className="absolute right-4 top-4" name="icon/ic_close.svg" style={{ zIndex: 4 }} size={32} />
      <div
        className="absolute left-0 right-0 top-0 h-[30dvh] rounded-t-lg px-12 py-8"
        style={{ background: ' linear-gradient(116deg, #FFADCF 1.5%, #FF4390 50.75%, #FF4390 100%)' }}
      >
        <div className="text-center typography-title-lg text-white">{brsc.time_buff}</div>
        <img className="w-full" src="/imgweb/sale/infinity_silver.png" alt="" />
      </div>
      {/* absolute 요소 공간 확보 4rem: bottomsheet padding, 1.5rem: bar height */}
      <div className="w-full" style={{ height: 'calc(30dvh - 4rem + 1.5rem)' }}></div>
      <div className="px-8 py-4 text-center typography-title-md text-white">{brsc.time_buff_sub_1.replace('$param', TimeBuffManager.BUFF_DURATION / (60 * 1000))}</div>
      <div className="flex-column align-center mt-2 flex w-full px-4">
        {products.map((product, index) => (
          <TimeBuffBundleItem key={`time-buff-bundle-${product.productId}`} onClick={() => handleClickBundle(product, index)} product={product} selected={index === selectedIdx} />
        ))}
      </div>
      <div className="flex-column mt-5 flex items-start justify-center gap-2 px-4 text-center text-white">
        <div className="pl-2 typography-headline-lg">Check point☝️</div>
        <ul className="m-0 px-4 py-0 text-start typography-body-sm">
          <li>{brsc.time_buff_sub_3.replace('$param', TimeBuffManager.BUFF_DURATION / (1000 * 60))}</li>
          <li>{brsc.time_buff_sub_4}</li>
          <li>{brsc.time_buff_sub_5.replace('$param', 14)}</li>
        </ul>
      </div>
    </div>
  );
};

interface TimeBuffBundleItemProps {
  selected?: boolean;
  product: Product;
  onClick: () => void;
}

const TimeBuffBundleItem: React.FC<TimeBuffBundleItemProps> = ({ selected, product: { count, price, price_currency_code, discountRate }, onClick }) => {
  return (
    <div
      onClick={onClick}
      className="flex-column align-center relative mt-2 flex w-full justify-center gap-3 rounded-lg px-8 py-3 text-white"
      style={{ border: `2px solid ${selected ? '#FFF' : 'transparent'}`, backgroundColor: 'rgba(255, 255, 255, 0.30)' }}
    >
      <div className="typography-headline-lg">{brsc.count_item.replace('$param', count)}</div>
      <div className="flex flex-row gap-1 rounded-xl px-4 py-1" style={{ backgroundColor: 'rgba(0, 0, 0, 0.50)' }}>
        <div className="typography-headline-lg">{`${PageShop.numberToCurrencyString(price, price_currency_code)}`}</div>
      </div>
      {discountRate && (
        <div className="absolute right-2 top-2 rounded-md px-2 py-1 typography-headline-md text-white" style={{ backgroundColor: 'rgba(255, 67, 144, 0.50)' }}>
          {discountRate}%
        </div>
      )}
    </div>
  );
};

export default TimeBuffPurchase;
